import { defineComponent as _defineComponent } from 'vue'
import { Modal } from '@/ui/components/Modal';
  import { Button } from '@/ui/components/Button';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ClosePromptModal',
  props: {
    active: { type: Boolean },
  },
  emits: ['close', 'leave'],
  setup(__props) {

  

  

return { __sfc: true,Modal, Button }
}

})